export enum Modo {
  LISTAGEM,
  CONSULTA,
  INCLUSAO,
  ALTERACAO,
  EXCLUSAO
}



// WEBPACK FOOTER //
// ./src/app/util/enum/modo.enum.ts